// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

ion-card {
  width: 100%;
  height: 100%;
  margin: var(--spacing-small) 0 0 0;
  overflow: hidden;
  box-sizing: border-box;
}

.table-content {
  padding: var(--spacing-small);
  height: 100%;
  overflow: auto;
}

.ag-root {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
@media (max-width: 599px) {
  .ag-root {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }
}

.ag-body-viewport {
  overflow-x: auto !important;
  overflow-y: auto !important;
}
@media (max-width: 599px) {
  .ag-body-viewport {
    flex: 1;
    overflow-x: scroll;
    overflow-y: auto;
  }
}

@media (min-width: 1024px) {
  .ag-body-horizontal-scroll {
    display: none !important;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .ag-body-horizontal-scroll {
    display: none !important;
  }
}
@media (max-width: 599px) {
  .ag-body-horizontal-scroll {
    display: block !important;
  }
}

.ag-cell {
  line-height: 1.2;
  font-size: clamp(4px, 1.7vmin, 18px);
}
@media (max-width: 599px) {
  .ag-cell {
    font-size: clamp(8px, 2.2vmin, 16px);
    min-width: 80px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.ag-header-cell-text {
  font-size: clamp(4px, 1.7vmin, 18px);
  font-weight: 600;
}
@media (max-width: 599px) {
  .ag-header-cell-text {
    font-size: clamp(8px, 2.2vmin, 16px);
  }
}

.ag-paging-panel {
  font-size: clamp(4px, 1.7vmin, 16px);
}
@media (max-width: 599px) {
  .ag-paging-panel {
    font-size: clamp(8px, 2.2vmin, 14px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-tables/maintenance-table/maintenance-table.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,6BAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AADJ;ACCE;EDHF;IAMQ,WAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;EAAN;AACF;;AAGA;EACI,2BAAA;EACA,2BAAA;AAAJ;ACZE;EDUF;IAKQ,OAAA;IACA,kBAAA;IACA,gBAAA;EACN;AACF;;ACLE;EDOF;IAEQ,wBAAA;EACN;AACF;AClBE;EDcF;IAMQ,wBAAA;EAEN;AACF;AC9BE;EDqBF;IAUQ,yBAAA;EAGN;AACF;;AAAA;EACI,gBAAA;EACA,oCAAA;AAGJ;ACxCE;EDmCF;IAKQ,oCAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EAIN;AACF;;AADA;EACI,oCAAA;EACA,gBAAA;AAIJ;ACtDE;EDgDF;IAKQ,oCAAA;EAKN;AACF;;AAFA;EACI,oCAAA;AAKJ;AC/DE;EDyDF;IAIQ,oCAAA;EAMN;AACF","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n:host {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: var(--spacing-small) 0 0 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.table-content {\r\n    padding: var(--spacing-small);\r\n    height: 100%;\r\n    overflow: auto;\r\n}\r\n\r\n.ag-root {\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n\r\n    @include bp.mobile {\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.ag-body-viewport {\r\n    overflow-x: auto !important;\r\n    overflow-y: auto !important;\r\n\r\n    @include bp.mobile {\r\n        flex: 1;\r\n        overflow-x: scroll;\r\n        overflow-y: auto;\r\n    }\r\n}\r\n\r\n.ag-body-horizontal-scroll {\r\n    @include bp.desktop {\r\n        display: none !important;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        display: none !important;\r\n    }\r\n\r\n    @include bp.mobile {\r\n        display: block !important;\r\n    }\r\n}\r\n\r\n.ag-cell {\r\n    line-height: 1.2;\r\n    font-size: clamp(4px, 1.7vmin, 18px);\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(8px, 2.2vmin, 16px);\r\n        min-width: 80px;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n.ag-header-cell-text {\r\n    font-size: clamp(4px, 1.7vmin, 18px);\r\n    font-weight: 600;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(8px, 2.2vmin, 16px);\r\n    }\r\n}\r\n\r\n.ag-paging-panel {\r\n    font-size: clamp(4px, 1.7vmin, 16px);\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(8px, 2.2vmin, 14px);\r\n    }\r\n}","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
